import {
    Component,
    ComponentRef,
    OnDestroy,
    OnInit,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { Subject } from "rxjs";
import { filter, takeUntil } from "rxjs/operators";
import { CommandService } from "~app/common/services/cqs/command.service";
import { DomService } from "~app/common/services/dom.service";
import { ObjectUtils } from "~app/common/utils/object-utils";

import {
    InitiateArbetsorderViol3SynchronizationCommand
} from "~app/features/administration/systemadministration/tabs/sysadm-viol3/commands/InitiateArbetsorderViol3SynchronizationCommand";
import { RequestMergeAllDestineringsalternativCommand } from "~app/features/planera/commands/RequestMergeAllDestineringsalternativCommand";
import { ArbetsorderEventStore } from "~app/features/shared/services/arbetsorderEventStore.service";
import { BusySpinnerComponent } from "../busy/busy-spinner/busy-spinner.component";

export interface IMassupdateArbetsorderItem {
    id: number;
    viol3: boolean;
}

@Component({
    selector: "rask-massupdate-arbetsordrar",
    templateUrl: "./massupdate-arbetsordrar.component.html",
    styleUrls: ["./massupdate-arbetsordrar.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [BusySpinnerComponent]
})
export class MassupdateArbetsordrarComponent implements OnInit, OnDestroy {
    arbetsordrar: IMassupdateArbetsorderItem[] = [];
    cmp: ComponentRef<any>;
    header: string;
    uppdateradeArbetsordrar: IMassupdateArbetsorderItem[] = [];

    private readonly arbetsorderEventStore = inject(ArbetsorderEventStore);
    private readonly commandService = inject(CommandService);
    private readonly domService = inject(DomService);
    private readonly ngUnsubscribe$ = new Subject<void>();

    close() {
        this.domService.removeComponentFromBody(this.cmp);
    }

    ngOnDestroy(): void {
        this.ngUnsubscribe$.next();
        this.ngUnsubscribe$.complete();
    }

    ngOnInit(): void {
        this.initEventListeners();
    }

    uppdateraDestineringsalternativ(checkAddIntressent = false) {
        this.uppdateradeArbetsordrar = [];
        const commandService = this.commandService.createInstance();
        this.arbetsorderEventStore.addArbetsorderList(this.arbetsordrar.map(x => x.id));
        this.arbetsordrar.forEach(ao => {
            const command = new RequestMergeAllDestineringsalternativCommand((x) => {
                x.arbetsorderId = ao.id;
                x.checkAddIntressent = checkAddIntressent;
            });
            commandService.addTransactionCommand(command);
        });
        commandService.pushCommandQueueTransaction();
    }

    uppdateraVirkesordrar(checkAddIntressent = false) {
        this.uppdateradeArbetsordrar = [];
        const commandService = this.commandService.createInstance();
        this.arbetsorderEventStore.addArbetsorderList(this.arbetsordrar.map(x => x.id));
        this.arbetsordrar.forEach(ao => {
            if (ao.viol3) {
                const command = new InitiateArbetsorderViol3SynchronizationCommand((x) => {
                    x.arbetsorderId = ao.id;
                    x.checkAddIntressent = checkAddIntressent;
                });
                commandService.addTransactionCommand(command);
            }

        });
        commandService.pushCommandQueueTransaction();
    }

    private completeUpdate() {
        setTimeout(() => {
            this.domService.removeComponentFromBody(this.cmp);
            this.uppdateradeArbetsordrar = [];
        }, 3000);
    }

    private handleArbetsorderSyncEvent(arbetsorderId: number) {
        if (!this.uppdateradeArbetsordrar.some(x => x.id === arbetsorderId)) {
            const ao = this.arbetsordrar.find(x => x.id === arbetsorderId);
            if (ObjectUtils.hasValue(ao)) {
                this.uppdateradeArbetsordrar.push(ao);
                this.arbetsorderEventStore.removeArbetsorderList([ao.id]);
            }
        }
        if (this.uppdateradeArbetsordrar.length === this.arbetsordrar.length) {
            this.completeUpdate();
        }
    }

    private initEventListeners() {
        this.arbetsorderEventStore.arbetsorderSynchFinished$
            .pipe(takeUntil(this.ngUnsubscribe$))
            .pipe(filter(x => this.arbetsordrar.some(y => y.id === x.arbetsorderId)))
            .subscribe(x => {
                this.handleArbetsorderSyncEvent(x.arbetsorderId);
            });

        this.arbetsorderEventStore.arbetsorderSynchAbort$
            .pipe(takeUntil(this.ngUnsubscribe$))
            .pipe(filter(x => this.arbetsordrar.some(y => y.id === x.arbetsorderId)))
            .subscribe(x => {
                this.handleArbetsorderSyncEvent(x.arbetsorderId);
            });

        this.arbetsorderEventStore.arbetsorderDestineringsalternativWorkCompleted$
            .pipe(takeUntil(this.ngUnsubscribe$))
            .pipe(filter(x => this.arbetsordrar.some(y => y.id === x.arbetsorderId)))
            .subscribe(event => {
                this.handleArbetsorderSyncEvent(event.arbetsorderId);
            });
    }
}
